import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

import { Col, Row } from 'common/components'

import PremiumsQueue, { MoveToNextPremium } from './premiumQueue'
import PremiumReviewHistory from './reviewHistory'
import ReviewPremiumForm from './reviewPremiumForm'

export const PREMIUMS_PATH = 'premiums'

const Premiums: React.FC = () => {
  const { id } = useParams<any>()

  const [selectedPremiumId, setSelectedPremiumId] = useState<string | null>()
  const [moveToNextPremium, setMoveToNextPremium] = useState<MoveToNextPremium>(null)

  useEffect(() => {
    if (id) {
      setSelectedPremiumId(id)
    }
  }, [id])

  return (
    <>
      <Row>
        {!id && (
          <Col span={6}>
            <PremiumsQueue
              onPremiumSelected={(item) => setSelectedPremiumId(item)}
              moveToNextPremium={moveToNextPremium}
            />
          </Col>
        )}

        <Col span={id ? 24 : 18} className={'mb-16'}>
          {selectedPremiumId && (
            <ReviewPremiumForm
              recurringExpenseId={selectedPremiumId}
              refreshAfterReview={!!id}
              onPremiumReviewed={(premiumId) => {
                setMoveToNextPremium({
                  currentRecurringExpenseId: premiumId,
                  removeCurrentRecurringExpenseIdFromQueue: true,
                })
              }}
              onPremiumSkipped={(premiumId) => {
                setMoveToNextPremium({
                  currentRecurringExpenseId: premiumId,
                  removeCurrentRecurringExpenseIdFromQueue: false,
                })
              }}
            />
          )}
        </Col>
      </Row>

      <Row>
        <Col span={!id ? 6 : 24}></Col>
        <Col span={id ? 24 : 18}>
          {selectedPremiumId && <PremiumReviewHistory recurringExpenseId={selectedPremiumId} />}
        </Col>
      </Row>
    </>
  )
}

export default Premiums
